import type { Video } from "@/types/video";

export const videos: Video[] = [
  {
    id: "v001",
    title: "夜色港湾",
    category: "night",
    type: "剧情短片",
    tags: ["夜色", "港湾", "浪漫", "城市"],
    duration: 742,
    publishedAt: "2026-10-12",
    views: 128400,
    cover:
      "https://readdy.ai/api/search-image?query=A%20cinematic%20still%20of%20a%20quiet%20harbor%20at%20midnight%20with%20deep%20crimson%20reflections%20on%20dark%20water%2C%20warm%20amber%20lanterns%20glowing%20along%20the%20pier%2C%20misty%20air%2C%20moody%20atmosphere%2C%20no%20people&width=800&height=450&seq=v001&orientation=landscape",
    summary: "午夜港口的两小时，海风把两个人的话都吹散了。",
    description:
      "这是一部以港口夜景为舞台的情绪短片。镜头沿着潮湿的码头缓慢移动，红灯笼的光落在水面上被拉成长长的线。全片几乎没有对白，依靠环境声与光线变化推进情绪，适合在深夜安静地看完。",
  },
  {
    id: "v002",
    title: "霓虹雨巷",
    category: "night",
    type: "剧情短片",
    tags: ["霓虹", "雨夜", "巷弄", "氛围"],
    duration: 616,
    publishedAt: "2026-10-08",
    views: 96700,
    cover:
      "https://readdy.ai/api/search-image?query=A%20cinematic%20still%20of%20a%20narrow%20rainy%20alley%20at%20night%20lit%20by%20deep%20red%20neon%20signs%2C%20wet%20asphalt%20mirroring%20the%20glow%2C%20soft%20bokeh%20in%20the%20distance%2C%20moody%20film%20grain%2C%20no%20people&width=800&height=450&seq=v002&orientation=landscape",
    summary: "雨停之前，她一直在巷口等一个不会来的人。",
    description:
      "雨、霓虹与狭窄的巷道构成了这部短片的全部空间。导演用大量特写记录雨滴撞在铁皮雨棚上的瞬间，红色招牌在积水里被反复打碎又拼合。故事克制，画面却有很强的记忆点。",
  },
  {
    id: "v003",
    title: "午夜天台",
    category: "night",
    type: "视觉写真",
    tags: ["天台", "夜景", "城市灯光", "自由"],
    duration: 428,
    publishedAt: "2026-10-03",
    views: 74100,
    cover:
      "https://readdy.ai/api/search-image?query=A%20cinematic%20rooftop%20terrace%20at%20night%20overlooking%20a%20dense%20city%20skyline%2C%20warm%20crimson%20and%20amber%20light%20haze%2C%20string%20lights%20and%20concrete%20texture%2C%20wide%20moody%20framing%2C%20no%20people&width=800&height=450&seq=v003&orientation=landscape",
    summary: "城市最高处的风，比地面上更自由一点。",
    description:
      "全片在天台完成拍摄，城市的灯带成为天然的背景板。摄影指导刻意压低曝光，只留下暖红与琥珀色的光斑，画面像一帧帧静止的摄影作品。适合喜欢视觉系内容的观众。",
  },
  {
    id: "v004",
    title: "灯火阑珊处",
    category: "night",
    type: "剧情短片",
    tags: ["灯火", "夜市", "温柔", "叙事"],
    duration: 883,
    publishedAt: "2026-09-26",
    views: 133200,
    cover:
      "https://readdy.ai/api/search-image?query=A%20cinematic%20night%20market%20scene%20with%20rows%20of%20glowing%20red%20lanterns%2C%20warm%20amber%20light%20falling%20on%20wooden%20stalls%2C%20shallow%20depth%20of%20field%20bokeh%2C%20nostalgic%20atmosphere%2C%20no%20people&width=800&height=450&seq=v004&orientation=landscape",
    summary: "夜市收摊之后，故事才真正开始。",
    description:
      "一部关于告别的短片。热闹的夜市在镜头里逐渐安静下来，摊主收灯、卷帘门落下，最后只剩下一盏没关的灯。导演用长镜头记录这个过程，情绪在沉默里慢慢积累。",
  },
  {
    id: "v005",
    title: "深夜放映厅",
    category: "night",
    type: "精选合集",
    tags: ["影院", "胶片", "深夜", "合集"],
    duration: 1620,
    publishedAt: "2026-09-18",
    views: 58200,
    cover:
      "https://readdy.ai/api/search-image?query=A%20vintage%20cinema%20auditorium%20with%20deep%20red%20velvet%20seats%2C%20a%20projector%20light%20beam%20cutting%20through%20haze%2C%20warm%20amber%20ambient%20glow%2C%20empty%20rows%2C%20cinematic%20wide%20shot%2C%20no%20people&width=800&height=450&seq=v005&orientation=landscape",
    summary: "四部深夜场短片的合集，适合一次看完。",
    description:
      "本期合集挑选了四部气质相近的深夜短片，统一以放映厅、走廊与散场后的空座位作为串联。合集的剪辑节奏经过重新调整，观感比单部作品更完整。",
  },
  {
    id: "v006",
    title: "城市最后一班车",
    category: "night",
    type: "剧情短片",
    tags: ["公交车", "通勤", "邂逅", "夜色"],
    duration: 537,
    publishedAt: "2026-09-09",
    views: 46800,
    cover:
      "https://readdy.ai/api/search-image?query=Interior%20of%20an%20empty%20late%20night%20bus%20with%20warm%20amber%20ceiling%20lights%2C%20rain%20streaks%20on%20the%20windows%2C%20red%20city%20lights%20blurring%20outside%2C%20cinematic%20moody%20atmosphere%2C%20no%20people&width=800&height=450&seq=v006&orientation=landscape",
    summary: "末班车上只剩下两个人，谁都没有先开口。",
    description:
      "几乎全部在移动的车厢内完成拍摄，窗外流动的红色灯带成为唯一的转场。对白很少，靠视线与距离的变化讲故事，是一部非常克制的小品。",
  },
  {
    id: "v007",
    title: "醉人的晚风",
    category: "night",
    type: "视觉写真",
    tags: ["晚风", "窗帘", "黄昏", "光影"],
    duration: 392,
    publishedAt: "2026-08-29",
    views: 63900,
    cover:
      "https://readdy.ai/api/search-image?query=Sheer%20white%20curtains%20blowing%20in%20a%20warm%20crimson%20sunset%20breeze%2C%20long%20shadows%20across%20a%20minimal%20room%2C%20golden%20dust%20in%20the%20air%2C%20soft%20film%20texture%2C%20tranquil%20mood%2C%20no%20people&width=800&height=450&seq=v007&orientation=landscape",
    summary: "一整个黄昏，都被风轻轻翻动。",
    description:
      "以窗帘、光斑和微风为主角的视觉短片。整部作品只用一个房间、一台摄影机，通过太阳角度的变化完成时间流逝的表达，画面干净到几乎没有多余元素。",
  },
  {
    id: "v008",
    title: "玻璃幕墙之下",
    category: "city",
    type: "剧情短片",
    tags: ["写字楼", "都市", "职场", "黄昏"],
    duration: 704,
    publishedAt: "2026-10-11",
    views: 112500,
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20glass%20skyscraper%20facade%20at%20dusk%20reflecting%20deep%20crimson%20sunset%20clouds%2C%20geometric%20window%20grid%2C%20warm%20amber%20highlights%2C%20minimal%20architectural%20photography%2C%20no%20people&width=800&height=450&seq=v008&orientation=landscape",
    summary: "同一栋楼里的两个人，隔着十七层互不相识。",
    description:
      "故事发生在一栋写字楼的黄昏时分。导演用建筑的几何线条切分画面，把两个人的生活并行剪辑，直到最后一刻才让他们出现在同一部电梯里。节奏干净利落。",
  },
  {
    id: "v009",
    title: "电梯里的三分钟",
    category: "city",
    type: "剧情短片",
    tags: ["电梯", "偶遇", "都市", "短片"],
    duration: 284,
    publishedAt: "2026-10-05",
    views: 152800,
    cover:
      "https://readdy.ai/api/search-image?query=Polished%20metal%20elevator%20interior%20with%20warm%20red%20accent%20lighting%2C%20brushed%20steel%20doors%2C%20soft%20reflections%2C%20tight%20cinematic%20framing%2C%20moody%20minimal%20composition%2C%20no%20people&width=800&height=450&seq=v009&orientation=landscape",
    summary: "三分钟，足够让一场偶遇变成一段回忆。",
    description:
      "全片只有一个场景，一台电梯。三分钟里，楼层数字不断跳动，气氛从尴尬到松弛再到沉默。编剧把情绪节点卡得非常准，是短篇叙事里完成度很高的一部。",
  },
  {
    id: "v010",
    title: "加班到凌晨",
    category: "city",
    type: "剧情短片",
    tags: ["加班", "办公室", "深夜", "疲惫"],
    duration: 611,
    publishedAt: "2026-09-28",
    views: 87300,
    cover:
      "https://readdy.ai/api/search-image?query=Late%20night%20open%20plan%20office%20lit%20by%20a%20single%20warm%20desk%20lamp%2C%20dark%20desks%20and%20monitors%20in%20shadow%2C%20red%20emergency%20light%20in%20the%20corridor%2C%20cinematic%20still%2C%20no%20people&width=800&height=450&seq=v010&orientation=landscape",
    summary: "灯只剩下一盏的时候，话反而说得更真。",
    description:
      "影片把舞台交给一间熄了大部分灯的办公室。两个人的对话从工作开始，最后聊到了谁都没准备好的人生问题。镜头语言朴素，但台词相当扎人。",
  },
  {
    id: "v011",
    title: "酒店走廊尽头",
    category: "city",
    type: "视觉写真",
    tags: ["走廊", "酒店", "对称", "灯光"],
    duration: 356,
    publishedAt: "2026-09-20",
    views: 59800,
    cover:
      "https://readdy.ai/api/search-image?query=A%20long%20hotel%20corridor%20with%20deep%20red%20carpet%2C%20warm%20wall%20sconces%2C%20symmetrical%20doors%2C%20strong%20one%20point%20perspective%2C%20moody%20cinematic%20lighting%2C%20luxurious%20atmosphere%2C%20no%20people&width=800&height=450&seq=v011&orientation=landscape",
    summary: "一条走廊，被镜头走成了很长的情绪。",
    description:
      "整部作品是一次对空间的凝视。摄影机贴着地毯缓慢前进，尽头的门始终没有被推开。极简的构图与稳定的运镜，让这段三分多钟的影像意外地耐看。",
  },
  {
    id: "v012",
    title: "首席设计师",
    category: "city",
    type: "剧情短片",
    tags: ["设计", "职场", "自信", "都市"],
    duration: 826,
    publishedAt: "2026-09-12",
    views: 77500,
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20design%20studio%20with%20a%20deep%20red%20accent%20chair%2C%20drafting%20table%2C%20fabric%20samples%20and%20warm%20afternoon%20light%2C%20clean%20architectural%20interior%2C%20elegant%20editorial%20mood%2C%20no%20people&width=800&height=450&seq=v012&orientation=landscape",
    summary: "她画下的每一根线，都有自己的脾气。",
    description:
      "一部节奏轻快的都市短片，围绕一次方案汇报展开。空间设计感很强，红色座椅与木色桌面构成了主视觉。剧情不复杂，但人物的状态很真实。",
  },
  {
    id: "v013",
    title: "顶楼泳池的夜色",
    category: "city",
    type: "视觉写真",
    tags: ["泳池", "顶楼", "夜色", "水光"],
    duration: 463,
    publishedAt: "2026-08-30",
    views: 91300,
    cover:
      "https://readdy.ai/api/search-image?query=Rooftop%20infinity%20pool%20at%20night%20with%20glowing%20red%20underwater%20lights%2C%20dark%20city%20skyline%20in%20the%20background%2C%20reflections%20rippling%20on%20the%20surface%2C%20luxurious%20cinematic%20mood%2C%20no%20people&width=800&height=450&seq=v013&orientation=landscape",
    summary: "水面上的红光，比整座城市都安静。",
    description:
      "这是一部以水为主题的视觉作品。摄影机贴近水面拍摄，红色水下灯把波纹染成流动的绸缎。全片没有对白，只有水声与远处的城市底噪。",
  },
  {
    id: "v014",
    title: "失踪的第七封信",
    category: "drama",
    type: "剧情短片",
    tags: ["信件", "悬疑", "旧物", "叙事"],
    duration: 948,
    publishedAt: "2026-10-09",
    views: 105600,
    cover:
      "https://readdy.ai/api/search-image?query=Old%20handwritten%20letters%20and%20a%20wax%20seal%20on%20a%20dark%20wooden%20desk%2C%20warm%20amber%20lamp%20light%2C%20dust%20particles%20in%20the%20air%2C%20shallow%20depth%20of%20field%2C%20nostalgic%20cinematic%20still%2C%20no%20people&width=800&height=450&seq=v014&orientation=landscape",
    summary: "前六封信都找到了，唯独第七封不见了。",
    description:
      "一部结构讲究的情感悬疑短片。故事从整理旧物开始，通过六封信回溯一段关系，而缺失的第七封信成了所有情绪的落点。叙事线索清晰，结尾留有余味。",
  },
  {
    id: "v015",
    title: "旧照片里的她",
    category: "drama",
    type: "剧情短片",
    tags: ["照片", "回忆", "旧时光", "温柔"],
    duration: 672,
    publishedAt: "2026-09-30",
    views: 68400,
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20photographs%20scattered%20across%20a%20linen%20surface%20with%20warm%20golden%20light%20falling%20across%20them%2C%20soft%20shadows%2C%20faded%20crimson%20tones%2C%20intimate%20nostalgic%20still%20life%2C%20no%20people&width=800&height=450&seq=v015&orientation=landscape",
    summary: "照片会褪色，但某个下午不会。",
    description:
      "影片用一组旧照片串起整段回忆，画面在现在的房间与过去的场景之间来回切换。色调统一在暖红与米白之间，情绪处理得相当温柔。",
  },
  {
    id: "v016",
    title: "雨季不再来",
    category: "drama",
    type: "剧情短片",
    tags: ["雨季", "窗", "告别", "情绪"],
    duration: 755,
    publishedAt: "2026-09-15",
    views: 52100,
    cover:
      "https://readdy.ai/api/search-image?query=Rain%20running%20down%20a%20large%20window%20with%20blurred%20warm%20red%20city%20lights%20beyond%2C%20condensation%20on%20the%20glass%2C%20soft%20melancholic%20cinematic%20lighting%2C%20intimate%20interior%20mood%2C%20no%20people&width=800&height=450&seq=v016&orientation=landscape",
    summary: "那年雨季结束时，谁都没有说再见。",
    description:
      "以雨为线索的叙事短片，窗玻璃上的水痕几乎贯穿全片。故事讲的是一段关系的结束，但导演把大部分镜头留给了空房间与雨声，克制而有力量。",
  },
  {
    id: "v017",
    title: "双人床单人房",
    category: "drama",
    type: "精选合集",
    tags: ["房间", "关系", "合集", "生活"],
    duration: 1388,
    publishedAt: "2026-09-04",
    views: 44900,
    cover:
      "https://readdy.ai/api/search-image?query=Hotel%20room%20with%20crisp%20white%20sheets%20and%20scattered%20red%20rose%20petals%2C%20warm%20bedside%20lamp%20glow%2C%20sheer%20curtains%2C%20elegant%20editorial%20interior%20still%2C%20soft%20shadows%2C%20no%20people&width=800&height=450&seq=v017&orientation=landscape",
    summary: "三段关于房间的短片，讲的都是关系。",
    description:
      "本期合集由三部独立短片组成，分别发生在酒店、公寓与出租屋。三部作品用同一套配色与镜头语言串联，主题都指向人与空间的关系。",
  },
  {
    id: "v018",
    title: "沉默的晚餐",
    category: "drama",
    type: "剧情短片",
    tags: ["晚餐", "沉默", "餐桌", "关系"],
    duration: 592,
    publishedAt: "2026-08-27",
    views: 39600,
    cover:
      "https://readdy.ai/api/search-image?query=A%20dimly%20lit%20restaurant%20table%20with%20candlelight%2C%20two%20empty%20plates%2C%20deep%20red%20wine%20glasses%2C%20dark%20wood%20interior%20and%20warm%20amber%20glow%2C%20cinematic%20still%20life%2C%20no%20people&width=800&height=450&seq=v018&orientation=landscape",
    summary: "整顿饭没有人说话，但每句话都在。",
    description:
      "影片把冲突藏进细节里：没动过的餐具、越来越短的蜡烛、被反复折叠的餐巾。全片对白极少，却把一个家庭多年积累的问题讲得很清楚。",
  },
  {
    id: "v019",
    title: "红丝绒光影",
    category: "visual",
    type: "视觉写真",
    tags: ["丝绒", "红光", "质感", "特写"],
    duration: 318,
    publishedAt: "2026-10-14",
    views: 143900,
    cover:
      "https://readdy.ai/api/search-image?query=A%20macro%20shot%20of%20deep%20red%20velvet%20fabric%20with%20golden%20light%20brushing%20across%20its%20surface%2C%20rich%20folds%20and%20texture%2C%20dark%20background%2C%20luxurious%20abstract%20cinematic%20texture%2C%20no%20people&width=800&height=450&seq=v019&orientation=landscape",
    summary: "把所有注意力交给一块红色丝绒。",
    description:
      "一部纯粹依靠材质说话的作品。摄影机用微距镜头贴着丝绒移动，光的入射角度每变化一次，红色的深浅就跟着改变。适合放大音量、关灯观看。",
  },
  {
    id: "v020",
    title: "琥珀色午后",
    category: "visual",
    type: "视觉写真",
    tags: ["午后", "纱帘", "阳光", "暖色"],
    duration: 342,
    publishedAt: "2026-10-06",
    views: 88700,
    cover:
      "https://readdy.ai/api/search-image?query=Amber%20afternoon%20sunlight%20pouring%20through%20sheer%20linen%20curtains%20into%20a%20quiet%20room%2C%20dust%20motes%20floating%2C%20warm%20golden%20tones%2C%20soft%20cinematic%20texture%2C%20peaceful%20minimal%20mood%2C%20no%20people&width=800&height=450&seq=v020&orientation=landscape",
    summary: "光从纱帘后面漏进来，整个房间都变软了。",
    description:
      "拍摄时间被严格限定在下午三点到五点之间，只为等那一段琥珀色的斜阳。全片几乎没有剪辑点，四分钟里只做了一件事：把光留住。",
  },
  {
    id: "v021",
    title: "镜面练习曲",
    category: "visual",
    type: "视觉写真",
    tags: ["镜子", "反射", "构图", "极简"],
    duration: 405,
    publishedAt: "2026-09-24",
    views: 51200,
    cover:
      "https://readdy.ai/api/search-image?query=An%20antique%20full%20length%20mirror%20in%20a%20dark%20room%20with%20soft%20crimson%20reflections%2C%20ornate%20frame%2C%20warm%20amber%20light%20falling%20across%20the%20glass%2C%20minimal%20moody%20cinematic%20composition%2C%20no%20people&width=800&height=450&seq=v021&orientation=landscape",
    summary: "镜子里外，是同一个空间的两种情绪。",
    description:
      "整部作品围绕一面旧镜子展开，画面通过反射形成层层嵌套的构图。红色与金色在镜面上交叠，几乎没有叙事的干扰，观感非常纯粹。",
  },
  {
    id: "v022",
    title: "烛光与丝绸",
    category: "visual",
    type: "视觉写真",
    tags: ["烛光", "丝绸", "暖光", "静谧"],
    duration: 377,
    publishedAt: "2026-09-07",
    views: 73600,
    cover:
      "https://readdy.ai/api/search-image?query=Flickering%20candles%20beside%20flowing%20silk%20fabric%20in%20a%20dark%20room%2C%20warm%20amber%20flame%20glow%20on%20soft%20crimson%20cloth%2C%20intimate%20quiet%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20no%20people&width=800&height=450&seq=v022&orientation=landscape",
    summary: "火苗晃一下，布料的颜色就换了一次。",
    description:
      "全片依靠烛光作为唯一光源，色温天然偏暖。摄影机保持固定机位，让画面里的光和布料自己完成变化，是一种非常安静的看法。",
  },
  {
    id: "v023",
    title: "暖色曝光",
    category: "visual",
    type: "精选合集",
    tags: ["胶片", "漏光", "合集", "暖色"],
    duration: 1180,
    publishedAt: "2026-08-22",
    views: 42800,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20film%20light%20leak%20in%20warm%20crimson%20and%20amber%20tones%2C%20grainy%20analog%20texture%2C%20soft%20glowing%20streaks%20over%20a%20dark%20frame%2C%20experimental%20cinematic%20still%2C%20no%20people&width=800&height=450&seq=v023&orientation=landscape",
    summary: "六段视觉小品，全部拍摄于同一天。",
    description:
      "合集收录了六段两分钟左右的视觉作品，统一使用过期胶片拍摄，漏光与颗粒被完整保留。整体像一本翻动的摄影集，适合当背景影像播放。",
  },
  {
    id: "v024",
    title: "九十年代录影带",
    category: "classic",
    type: "精选合集",
    tags: ["录像带", "九十年代", "复古", "怀旧"],
    duration: 1456,
    publishedAt: "2026-09-22",
    views: 62400,
    cover:
      "https://readdy.ai/api/search-image?query=A%20stack%20of%20vintage%20VHS%20tapes%20beside%20a%20glowing%20CRT%20television%2C%20warm%20red%20screen%20light%20in%20a%20dark%20room%2C%20analog%20scan%20lines%2C%20nostalgic%20retro%20cinematic%20still%2C%20no%20people&width=800&height=450&seq=v024&orientation=landscape",
    summary: "倒带、雪花点，和那个年代的画质。",
    description:
      "本片整理了一批九十年代的影像素材，保留了原始磁带的时间码与噪点。色彩被刻意压回暖调，画面边缘的暗角也一并保留，怀旧感相当到位。",
  },
  {
    id: "v025",
    title: "午夜场记忆",
    category: "classic",
    type: "精选合集",
    tags: ["影院", "午夜场", "复古", "招牌"],
    duration: 1264,
    publishedAt: "2026-09-01",
    views: 47300,
    cover:
      "https://readdy.ai/api/search-image?query=An%20old%20cinema%20marquee%20at%20night%20with%20glowing%20red%20bulbs%2C%20weathered%20signage%2C%20rain%20slicked%20street%2C%20warm%20amber%20light%20spilling%20from%20the%20entrance%2C%20retro%20cinematic%20mood%2C%20no%20people&width=800&height=450&seq=v025&orientation=landscape",
    summary: "那些只在午夜放映的电影，后来都成了记忆。",
    description:
      "一部关于老影院的回顾合集，素材来自多部旧作的重新剪辑。红色灯泡、手写排片表与湿漉漉的街道，构成了整部作品最鲜明的视觉符号。",
  },
  {
    id: "v026",
    title: "旧港片残影",
    category: "classic",
    type: "视觉写真",
    tags: ["港片", "残影", "胶片", "街头"],
    duration: 508,
    publishedAt: "2026-08-25",
    views: 38900,
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%2035mm%20film%20reels%20and%20a%20spinning%20projector%20in%20a%20dusty%20room%2C%20warm%20amber%20light%20beams%2C%20deep%20red%20shadows%2C%20grainy%20analog%20film%20texture%2C%20nostalgic%20still%2C%20no%20people&width=800&height=450&seq=v026&orientation=landscape",
    summary: "颗粒感和红色调，是那个年代的签名。",
    description:
      "作品以胶片盘和放映机为拍摄主体，配合大量跳切与叠化，模拟旧港片的视觉节奏。色彩偏暖红，暗部保留得很完整，适合喜欢复古质感的观众。",
  },
  {
    id: "v027",
    title: "黑白胶片之夜",
    category: "classic",
    type: "精选合集",
    tags: ["黑白", "胶片", "夜晚", "经典"],
    duration: 1102,
    publishedAt: "2026-08-18",
    views: 33700,
    cover:
      "https://readdy.ai/api/search-image?query=A%20black%20and%20white%20film%20strip%20curling%20over%20a%20dark%20surface%20with%20a%20single%20deep%20red%20light%20accent%2C%20high%20contrast%20shadows%2C%20grainy%20analog%20texture%2C%20minimal%20cinematic%20still%2C%20no%20people&width=800&height=450&seq=v027&orientation=landscape",
    summary: "去掉颜色之后，光反而更清楚了。",
    description:
      "合集以黑白影像为主，只在少数画面里保留一抹红色作为视觉锚点。整体节奏偏慢，适合当作夜间播放的氛围内容。",
  },
  {
    id: "v028",
    title: "灯光师的手记",
    category: "behind",
    type: "幕后访谈",
    tags: ["幕后", "灯光", "访谈", "制作"],
    duration: 921,
    publishedAt: "2026-10-10",
    views: 29400,
    cover:
      "https://readdy.ai/api/search-image?query=A%20film%20studio%20lighting%20rig%20with%20warm%20red%20gels%20and%20softboxes%20glowing%20in%20a%20dark%20soundstage%2C%20cables%20and%20stands%2C%20cinematic%20behind%20the%20scenes%20still%2C%20no%20people&width=800&height=450&seq=v028&orientation=landscape",
    summary: "一部片子的情绪，其实是被灯决定的。",
    description:
      "本期访谈请到一位从业十余年的灯光师，聊红色在影像里的用法、如何用一盏灯制造空间感，以及片场里那些不为人知的取舍。信息密度很高。",
  },
  {
    id: "v029",
    title: "导演谈一场戏",
    category: "behind",
    type: "幕后访谈",
    tags: ["导演", "幕后", "调度", "访谈"],
    duration: 834,
    publishedAt: "2026-09-17",
    views: 25100,
    cover:
      "https://readdy.ai/api/search-image?query=A%20director%20chair%20on%20an%20empty%20dark%20film%20set%2C%20deep%20red%20practical%20light%20in%20the%20background%2C%20cables%20and%20camera%20rig%20silhouettes%2C%20moody%20behind%20the%20scenes%20still%2C%20no%20people&width=800&height=450&seq=v029&orientation=landscape",
    summary: "一场三分钟的戏，拍了整整两天。",
    description:
      "访谈围绕一场关键戏的调度展开，从机位设计到演员走位，逐帧拆解了拍摄过程。对喜欢研究镜头语言的观众来说，这一期含金量很高。",
  },
  {
    id: "v030",
    title: "片场之外的对谈",
    category: "behind",
    type: "幕后访谈",
    tags: ["对谈", "录音", "片场", "创作"],
    duration: 1063,
    publishedAt: "2026-08-20",
    views: 21800,
    cover:
      "https://readdy.ai/api/search-image?query=A%20vintage%20microphone%20in%20a%20smoky%20recording%20studio%20with%20warm%20red%20and%20amber%20lighting%2C%20acoustic%20foam%20walls%2C%20shallow%20depth%20of%20field%2C%20cinematic%20interview%20still%2C%20no%20people&width=800&height=450&seq=v030&orientation=landscape",
    summary: "收工之后，聊聊创作这件事。",
    description:
      "一期偏闲聊的幕后对谈，录制于片场附近的录音棚。话题从项目筹备聊到个人审美，节奏松弛，适合当作播客来听。",
  },
];